import React from 'react';

export class TagObrigatorio extends React.Component{
    render(){
        return(
          <a className="required-field" color="red">*</a>
        );
    }
}